import { css } from "@emotion/css";

export const nameWidth = css`
    flex: 1 0 0%;
    min-width: 100px;
`;

export const idWidth = css`
    flex: 1 0 0%;
    min-width: 100px;
`;

export const dateWidth = css`
    flex-shrink: 0;
    width: 150px;
`;

export const baseWidth = css`
    flex-shrink: 0;
    width: 100px;
`;

export const dropdownWidth = css`
    flex-shrink: 0;
    width: 28px;
`;
